import { useTranslation } from 'react-i18next';
import { Button, ButtonOption, ButtonSize } from '../../Fundamentals/Button';
import DropdownMenu from '../../Fundamentals/DropdownMenu/DropdownMenu';
import SpirisIcon from '../../Fundamentals/Icon/SpirisIcon';
import { nextVersionStatus, secondaryVersionTransitions, versionTransitionConfig } from './versionUtils';
import type { VossVersionStatus } from '../../../Constants/VOSS/vossVersionStatus';

interface PackageVersionActionsProps {
    currentStatus: VossVersionStatus | undefined;
    onShowHistory: () => void;
    onCreateVersion: () => void;
    onChangeStatus: (target: VossVersionStatus) => void;
}

const PackageVersionActions = ({ currentStatus, onShowHistory, onCreateVersion, onChangeStatus }: PackageVersionActionsProps) => {
    const { t } = useTranslation();

    const next = nextVersionStatus(currentStatus);

    return (
        <div className="d-flex align-items-center gap-8">
            <Button size={ButtonSize.DEFAULT} onClick={onShowHistory}>
                <SpirisIcon name="history" size="sm" className="mr-8" />
                {t('packages.versionHistory')}
            </Button>
            {next !== undefined && (
                <Button option={ButtonOption.PRIMARY} size={ButtonSize.DEFAULT} onClick={() => onChangeStatus(next)}>
                    <SpirisIcon name={versionTransitionConfig[next].icon} size="sm" className="mr-8" />
                    {t(versionTransitionConfig[next].actionKey)}
                </Button>
            )}
            <DropdownMenu
                label={t('packages.versionActions') ?? ''}
                triggerClassName="btn btn-icon btn-lg"
                trigger={<SpirisIcon name="vertical-menu" />}
                items={[
                    { key: 'create', label: t('packages.createVersion'), icon: 'plus', onClick: onCreateVersion },
                    ...secondaryVersionTransitions(currentStatus).map((target) => {
                        const config = versionTransitionConfig[target];

                        return {
                            key: `status-${target}`,
                            label: t(config.actionKey),
                            icon: config.icon,
                            destructive: config.destructive,
                            onClick: () => onChangeStatus(target),
                        };
                    }),
                ]}
            />
        </div>
    );
};

export default PackageVersionActions;
